var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('nav-bar',{attrs:{"title":"用户协议","left-arrow":""}}),(_vm.list)?_c('div',{staticClass:"htmlcontentbox content",domProps:{"innerHTML":_vm._s(_vm.list)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }